import { AbstractControl, AsyncValidatorFn, FormGroup } from '@angular/forms';
import { Observable, from, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SignUpFormValidationService } from '../../../shared/services/signUpFormValidationService.service';

export const MustMatch = (c: FormGroup): { [key: string]: any } => {
  if (c.value.passwordControl === c.value.passwordConfirmControl) {
    return null;
  } else {
    return {
      passwordMatch: 'not matching',
    };
  }
};

@Injectable()
export class CustomEmailValidator {
  constructor(
    private localSignUpFormService: SignUpFormValidationService,
    private http: HttpClient
  ) {}

  asyncUsernameValidation(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<any> =>
      from(this.localSignUpFormService.verifyUsername({ username: control.value })).pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap<any, any>((res) => {
          if (res.response.result === 'Valid') {
            return of(null);
          } else {
            return of({ invalid: true });
          }
        })
      );
  }

  asyncEmailValidation(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<any> =>
      from(this.localSignUpFormService.verifyEmail({ email: control.value })).pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap<any, any>((res) => {
          if (res.response.result === 'Valid') {
            return of(null);
          } else {
            return of({ invalid: true });
          }
        })
      );
  }
}
